module.exports = __webpack_public_path__ + "static/media/2C.fcc07e4c.png";